import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  items: [],
  totalQuantity: 0,
  isVisible: false,
};

export const cartNotificationSlice = createSlice({
  name: 'cartNotification',
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.items = action.payload.items || [];
      state.totalQuantity = action.payload.totalQuantity || 0;
      state.isVisible = true;
    },
    hideNotification: (state) => {
      state.items = [];
      state.totalQuantity = 0;
      state.isVisible = false;
    },
  },
});

export const {showNotification, hideNotification} = cartNotificationSlice.actions;

export const selectCartNotification = (state) => state.cartNotification;
export const selectCartNotificationVisible = (state) => state.cartNotification.isVisible;

export default cartNotificationSlice.reducer;
